<template>
  <div class="post-meta-details">
    <p>
      <span v-if="authorFirstName" class="post-meta-header-author">
        {{ $t("blog.by") }} {{ authorFullNameNotPaul }},
        {{ getFormattedDate(date) }}
      </span>
    </p>
    <div v-if="hasDuration" class="reading-duration">Geschätzte Lesedauer: ⏳ 4 min</div>
  </div>
</template>

<script>
export default {
  props: {
    authorFirstName: {
      type: String,
      required: true,
    },
    authorLastName: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    hasDuration: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    authorFullNameNotPaul: function () {
      if (this.authorFirstName === "Paul") {
        return "memodio Redaktion"
      } else {
        return this.authorFirstName + " " + this.authorLastName
      }
    },
  },
  methods: {
    getFormattedDate(date) {
      const dateObject = new Date(date)
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      }
      return dateObject.toLocaleDateString(this.$i18n.locale, options)
    },
  },
}
</script>

<style scoped>
.post-meta-details p {
  font-weight: lighter;
  margin-bottom: 8px;
}

.reading-duration {
  font-weight: bold;
}
</style>
